export const CertificateCohLogo = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="102"
      height="34"
      viewBox="0 0 102 34"
      fill="none"
    >
      <path
        d="M22.6134 19.7952L20.3258 20.3185L23.3105 33.419L25.598 32.8957L22.6134 19.7952Z"
        fill="#232329"
      />
      <path
        d="M22.155 14.4413L21.1371 16.5597L33.2195 22.3892L34.2374 20.2707L22.155 14.4413Z"
        fill="#232329"
      />
      <path
        d="M29.7761 5.63545L17.6937 11.4649L18.7116 13.5833L30.794 7.75388L29.7761 5.63545Z"
        fill="#232329"
      />
      <path
        d="M4.15393 6.15308L2.31942 7.61898L10.6802 18.1251L12.5147 16.6592L4.15393 6.15308Z"
        fill="#232329"
      />
      <path d="M13.41 20.3967H0V22.7479H13.41V20.3967Z" fill="#232329" />
      <path
        d="M16.8865 22.0279L8.52575 32.534L10.3603 33.9999L18.721 23.4938L16.8865 22.0279Z"
        fill="#232329"
      />
      <path
        d="M46.1973 6.74518C47.4677 6.74518 48.3708 7.25222 48.8746 8.38824H50.7726C50.1578 6.34725 48.6419 5.1171 46.1952 5.1171C43.2574 5.1171 41.2228 7.22441 41.2228 10.196C41.2228 13.1677 43.2446 15.2471 46.1696 15.2471C48.5885 15.2471 50.2538 13.9742 50.7598 11.976H48.8597C48.4626 13.0029 47.6427 13.6191 46.1952 13.6191C44.3911 13.6191 43.1357 12.1536 43.1357 10.196C43.1357 8.23848 44.3783 6.74518 46.1952 6.74518H46.1973Z"
        fill="#232329"
      />
      <path d="M53.6997 7.99024H51.8551V15.0695H53.6997V7.99024Z" fill="#232329" />
      <path d="M53.7808 5.29259H51.8679V6.99128H53.7808V5.29259Z" fill="#232329" />
      <path
        d="M57.2118 7.99036H55.4077V15.0696H57.2524V11.9076C57.2524 10.2367 57.8395 9.89442 58.4416 9.74467C58.7021 9.63556 59.2486 9.63556 59.3575 9.63556V7.89623C58.3882 7.90906 57.6089 8.26634 57.2118 9.19698V7.99036Z"
        fill="#232329"
      />
      <path
        d="M63.6873 15.2751C65.3825 15.2751 66.7468 14.3573 67.035 12.6607H65.3142C65.0964 13.4694 64.426 13.8374 63.6873 13.8374C62.4704 13.8374 61.721 12.8233 61.721 11.5375C61.721 10.2518 62.4725 9.23768 63.6873 9.23768C64.4516 9.23768 65.026 9.6078 65.2715 10.3331H66.9923C66.7468 8.75845 65.3932 7.78717 63.6852 7.78717C61.6228 7.78717 59.8998 9.16922 59.8998 11.5247C59.8998 13.8802 61.6206 15.2772 63.6852 15.2772L63.6873 15.2751Z"
        fill="#232329"
      />
      <path d="M70.1521 5.29259H68.3074V15.0675H70.1521V5.29259Z" fill="#232329" />
      <path
        d="M75.0007 7.77212C72.8956 7.77212 71.352 9.34672 71.352 11.5097C71.352 13.6726 72.8423 15.2878 74.9858 15.2878C76.7216 15.2878 77.9641 14.385 78.3869 12.988H76.5422C76.2817 13.5635 75.6818 13.8095 74.9837 13.8095C73.9866 13.8095 73.2479 13.1249 73.1113 12.0424H78.4808C78.4936 11.9054 78.4936 11.7557 78.4936 11.6872C78.4808 9.53713 77.345 7.77212 74.9965 7.77212H75.0007ZM73.1305 10.825C73.2949 9.83878 73.9781 9.16915 74.9879 9.16915C76.0939 9.16915 76.6148 9.97784 76.7237 10.825H73.1305Z"
        fill="#232329"
      />
      <path
        d="M87.6272 15.3007C90.8788 15.3007 92.7512 12.9174 92.7512 10.1811C92.7512 7.44481 90.8788 5.06152 87.6272 5.06152C84.3756 5.06152 82.5032 7.44481 82.5032 10.1811C82.5032 12.9174 84.3756 15.3007 87.6272 15.3007ZM87.6272 6.68961C89.6213 6.68961 90.8254 8.27704 90.8254 10.1811C90.8254 12.0852 89.6234 13.6726 87.6272 13.6726C85.631 13.6726 84.4161 12.0852 84.4161 10.1811C84.4161 8.27704 85.6053 6.68961 87.6272 6.68961Z"
        fill="#232329"
      />
      <path
        d="M96.3443 9.38735H97.5464V7.99033H96.3443V7.77211C96.3443 6.89495 96.5493 6.67674 97.2325 6.67674H97.5741V5.29468H96.7265C94.9907 5.29468 94.4997 6.25314 94.4997 7.69081V7.99247H93.5155V9.38949H94.4997V15.0717H96.3443V9.38735Z"
        fill="#232329"
      />
      <path
        d="M47.6726 22.611H43.6567V18.5569H41.7437V28.3339H43.6567V24.2519H47.6726V28.3339H49.5856V18.5569H47.6726V22.611Z"
        fill="#232329"
      />
      <path
        d="M55.9393 24.3887C55.9393 26.0874 55.3522 26.9218 54.4085 26.9218C53.3965 26.9218 53.166 26.0446 53.166 25.0605V21.2545H51.3341V25.5397C51.3341 27.3197 52.0451 28.5392 53.862 28.5392C54.9551 28.5392 55.5977 27.9508 55.9799 27.1421V28.3338H57.784V21.2545H55.9393V24.3909V24.3887Z"
        fill="#232329"
      />
      <path
        d="M67.035 21.0491C65.9974 21.0491 65.4636 21.5412 65.0665 22.3627C64.7121 21.4727 64.0695 21.0491 63.1408 21.0491C62.1031 21.0491 61.4605 21.7337 61.2278 22.4055V21.2545H59.4237V28.3338H61.2684V25.1974C61.2684 23.8432 61.5288 22.6644 62.5792 22.6644C63.5635 22.6644 63.7129 23.5266 63.7129 24.5257V28.3316H65.4893V24.9642C65.4893 23.5544 65.9803 22.6644 66.7874 22.6644C67.6755 22.6644 67.9082 23.5266 67.9082 24.5257V28.3316H69.7251V24.0464C69.7251 22.2536 68.8242 21.0491 67.0329 21.0491H67.035Z"
        fill="#232329"
      />
      <path
        d="M77.3792 24.0743C77.3792 22.2258 76.4504 21.0214 74.3047 21.0214C72.4473 21.0214 71.4631 22.2408 71.2453 23.4303H72.9661C73.1433 22.7864 73.6365 22.3906 74.3197 22.3906C75.084 22.3906 75.5772 22.7051 75.5772 23.2527C75.5772 23.8561 75.099 23.978 74.198 24.1021C73.2287 24.2518 70.9336 24.4722 70.9336 26.4019C70.9336 27.6214 71.8901 28.5242 73.4059 28.5242C74.704 28.5242 75.3061 27.8525 75.605 27.2791H75.6178V27.6492C75.6178 27.8546 75.6306 28.1156 75.6733 28.3338H77.5051C77.409 27.8674 77.3813 27.1015 77.3813 26.5538V24.0764L77.3792 24.0743ZM75.6028 25.0477C75.6028 26.6779 74.7958 27.1828 73.9354 27.1828C73.1433 27.1828 72.7611 26.7849 72.7611 26.3057C72.7611 25.7986 73.1582 25.5119 74.087 25.3194C75.0563 25.1269 75.4384 24.8273 75.6028 24.485V25.0477Z"
        fill="#232329"
      />
      <path
        d="M82.8448 21.0491C81.7516 21.0491 81.109 21.6246 80.7268 22.4462V21.2545H78.9228V28.3338H80.7674V25.1974C80.7674 23.4988 81.3695 22.6644 82.2982 22.6644C83.3102 22.6644 83.5408 23.5266 83.5408 24.5257V28.3316H85.3726V24.0464C85.3726 22.2536 84.6617 21.0491 82.8448 21.0491Z"
        fill="#232329"
      />
      <path d="M88.8847 18.5569H86.9717V20.2555H88.8847V18.5569Z" fill="#232329" />
      <path d="M88.8014 21.2545H86.9568V28.3338H88.8014V21.2545Z" fill="#232329" />
      <path
        d="M92.7789 18.8713L90.9748 19.665V21.2524H89.8262V22.6495H90.9748V25.8393C90.9748 27.3176 91.4531 28.4002 93.27 28.3724L94.1453 28.3595V26.894H93.7076C92.9156 26.894 92.7789 26.4148 92.7789 25.5655V22.6495H94.2008V21.2524H92.7789V18.8713Z"
        fill="#232329"
      />
      <path
        d="M100.074 21.2545C99.5149 23.1158 98.9405 24.8273 98.5157 26.3613H98.4879C97.9136 24.5963 97.3542 23.0473 96.7671 21.2545H94.8264C95.6462 23.5137 96.4789 25.636 97.5314 28.4707L97.3542 28.9906C97.2048 29.4698 96.9721 29.6623 96.4789 29.6623H95.7273V31.0722H97.1215C98.078 31.0722 98.6374 30.593 98.9534 29.7436C101.304 23.1586 99.7732 27.5401 102 21.2545H100.074Z"
        fill="#232329"
      />
      <path
        d="M15.5721 0L12.5874 13.1005L14.8749 13.6238L17.8596 0.523305L15.5721 0Z"
        fill="#D5F477"
      />
    </svg>
  );
};
